/* unplugin-vue-components disabled */import { render } from "./user_address.vue?vue&type=template&id=65fd26ba&scoped=true"
import script from "./user_address.vue?vue&type=script&lang=js"
export * from "./user_address.vue?vue&type=script&lang=js"

import "./user_address.vue?vue&type=style&index=0&id=65fd26ba&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fd26ba"]])

export default __exports__